import { cardContentStyle, cardHeaderStyle } from 'styles/shared/CardStyle';

export const container = {
  borderRadius: '1rem',
  border: '1px solid #e5e7eb',
  borderLeft: '2px solid #e5e7eb'
};

export const header = (isExpanded: boolean) => ({
  ...cardHeaderStyle,
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  cursor: 'pointer',
  borderBottom: isExpanded ? '1px solid #f0f0f0' : 'none',
  borderRadius: isExpanded ? '16px 16px 0 0' : '16px'
});

export const title = {
  fontSize: '0.75rem',
  fontWeight: 600
};

export const checkmarkContainer = (borderColor: string) => ({
  width: 20,
  height: 20,
  borderRadius: '50%',
  border: `1.5px solid ${borderColor}`,
  backgroundColor: 'common.white',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center'
});

export const checkmarkIcon = (color: string) => ({
  color,
  fontSize: 14
});

export const content = cardContentStyle;

export const toggleWrapper = (isPrepaid: boolean) => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'flex-start',
  border: '1px solid #e5e7eb',
  borderRadius: '6px',
  px: 1.5,
  py: 1,
  backgroundColor: 'transparent',
  ...(isPrepaid && {
    borderColor: 'rgba(22, 163, 74, 0.3)',
    backgroundColor: 'rgba(22, 163, 74, 0.04)'
  })
});

export const toggleLabel = (isPrepaid: boolean) => ({
  m: 0,
  '& .MuiFormControlLabel-label': {
    color: isPrepaid ? '#16A34A' : 'inherit'
  }
});

export const switchStyle = {
  '& .MuiSwitch-switchBase.Mui-checked': {
    color: '#16A34A',
    '& + .MuiSwitch-track': {
      backgroundColor: '#16A34A'
    },
    '& .MuiSwitch-thumb': {
      backgroundColor: '#16A34A'
    }
  }
};

export const paymentChannelLabel = {
  mb: 1,
  textAlign: 'left',
  color: '#9CA3AF',
  fontSize: '0.875rem',
  textTransform: 'uppercase'
};

export const paymentChannelOption = (isSelected: boolean) => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  px: 1.5,
  py: 1,
  borderRadius: '4px',
  border: `1px solid ${isSelected ? '#078DEE' : '#e5e7eb'}`,
  backgroundColor: isSelected ? 'rgba(7, 141, 238, 0.07)' : 'transparent',
  color: isSelected ? '#078DEE' : 'inherit',
  cursor: 'pointer',
  fontSize: '0.875rem',
  fontWeight: isSelected ? 600 : 400
});
